import React from "react";
import Dialog from "@mui/material/Dialog";
import {
  Box,
  Typography,
  Button,
  IconButton,
  DialogTitle,
} from "@mui/material";
import useMobile from "../../../hooks/useMobile";

interface ConfirmationProps {
  onChange: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  approvalStatus: string;
  rejectionReason: string;
  setRejectionReason: React.Dispatch<React.SetStateAction<string>>;
}

const StatusConfirmation: React.FC<ConfirmationProps> = ({
  onChange,
  open,
  setOpen,
  approvalStatus,
  rejectionReason,
  setRejectionReason,
}) => {
  const mobile = useMobile();
  const handleClose = () => {
    setOpen(false);
    setRejectionReason("");
  };

  const changeStatus = () => {
    onChange();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      PaperProps={{
        sx: {
          marginTop: "60px",
          alignSelf: "flex-start",
          borderRadius: 2,
          minWidth: mobile ? "auto" : "400px",
        },
      }}
    >
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            fontSize: "15px",
          }}
        >
          <i className="icon-cross1"></i>
        </IconButton>
      </DialogTitle>
      <hr />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        padding="0px 15px 15px 15px"
        minWidth="300px"
      >
        {approvalStatus === "Rejected" && (
          <div className="col-xl-12">
            <div
              className="become-volunteer__input become-volunteer__message-box"
              style={{ height: "100px" }}
            >
              <textarea
                name="reason"
                placeholder="Reason For Rejection"
                value={rejectionReason}
                onChange={(e) =>
                  setRejectionReason && setRejectionReason(e.target.value)
                }
                style={{ height: "100px" }}
              ></textarea>
            </div>
          </div>
        )}
        <Typography variant="subtitle1" fontWeight={500} mb={3}>
          Are you sure you want to change status?
        </Typography>

        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#2BB1CE",
              color: "#fff",
              width: "80px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "#48c5dd",
              },
            }}
            onClick={changeStatus}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "hsl(6, 78%, 57%);",
              color: "#fff",
              width: "80px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: "hsl(6, 78%, 65%)",
              },
            }}
            onClick={handleClose}
          >
            No
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default StatusConfirmation;
